import type { ProvinceSeoOverrides } from "../_types";

export const PHUKET_SEO: ProvinceSeoOverrides = {
  primaryKeywords: [
    "Notary Public ภูเก็ต",
    "ทนายรับรองเอกสารภูเก็ต",
    "แปลเอกสารภูเก็ต",
    "NAATI ภูเก็ต",
    "MFA รับรองเอกสารภูเก็ต",
    "Police Clearance ภูเก็ต",
    "จดทะเบียนสมรสต่างชาติภูเก็ต",
    "Work Permit ภูเก็ต",
    "Notary Public Phuket",
    "Apostille Phuket",
  ],
  longTailKeywords: [
    "notary ป่าตอง",
    "รับรองเอกสารใกล้สนามบินภูเก็ต",
    "แปลเอกสาร PSU Phuket",
    "Mobile notary ราไวย์",
    "Affidavit อำเภอเมืองภูเก็ต",
    "Retirement Visa ตม.ภูเก็ต",
    "DTV Visa Phuket Digital Nomad",
    "Yacht Charter Agreement Royal Phuket Marina",
    "นักลงทุนวิลล่าล็อคปาล์ม",
    "แปลรัสเซีย-จีน ภูเก็ต",
  ],
  marketLocales: ["en", "ru", "zh", "ar"],
};